import { Button, notification } from 'antd';
import { BellOutlined } from '@ant-design/icons';
import React from 'react';
import BlueTooth from './BluetoothButton';

function SmartBell (props) {
    const { device, onClose } = props;

    return (
        <div className="deviceModal" style={{textAlign: 'center'}}>
            <BlueTooth device={device} onClose={onClose} />
            <Button 
                type='primary'
                icon={<BellOutlined />}
                onClick={() => {
                    try {
                        device.pressDoorBell();
                    }
                    catch(e) {
                        notification.error({
                            message: '出错啦',
                            description: e.message
                        });
                    }
                }}
            >门铃</Button>
        </div>
    );
}

export default SmartBell;